import { SortDescriptor } from '@progress/kendo-data-query'
import {
  PaymentProviderFilterKey,
  PaymentProviderKey,
} from 'api/PaymentProvider/Types/PaymentProviderGroupDto'

export const normalizePaymentProvidersSortQuery = (
  sortDescriptors: SortDescriptor[]
): SortDescriptor[] =>
  sortDescriptors
    .map((x) => {
      if (x.field === PaymentProviderKey.name) {
        return { ...x, field: PaymentProviderFilterKey.name }
      }
      return x
    })
    .filter((x) => !!x)
